import { ensureBundledocsActionCompleted, isBundledocsAuthRequiredError } from './ensureBundledocsActionCompleted'
import {
  extractDownloadBundleErrorMessage,
  useDocumentBundleWizardStore
} from '@repo/store/useDocumentBundleWizardStore'
import { useToastStore } from '@repo/store/useToastStore'

export const downloadBundle = async (bundleData: any) => {
  let blob: Blob | undefined

  try {
    blob = await ensureBundledocsActionCompleted(bundleData, (suppressErrorToast: boolean) =>
      useDocumentBundleWizardStore.getState().downloadBundle({
        matterBundleId: bundleData?.matterBundleId,
        suppressErrorToast
      })
    )
  } catch (err: any) {
    if (!isBundledocsAuthRequiredError(err)) {
      const message = await extractDownloadBundleErrorMessage(err)
      useToastStore.getState().showToast({ type: 'error', title: 'Error', text: message || 'Error downloading bundle' })
    }
    throw err
  }

  if (!blob) return

  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = bundleData?.name ? `${bundleData.name}.pdf` : `bundle_${bundleData?.matterBundleId}.pdf`
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
